import React, { useState, useEffect } from "react";
import "./Navbar.css";

const NAV_LINKS = [
  { href: "#dienstleistungen", label: "Dienstleistungen" },
  { href: "#projekte",         label: "Projekte"         },
  { href: "#traumgarten",      label: "Traumgarten"      },
  { href: "#über-uns",         label: "Über uns"         },
  { href: "#bewertungen",      label: "Bewertungen"      },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((v) => !v);
  const closeMenu  = () => setIsMenuOpen(false);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isMenuOpen]);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") closeMenu(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <nav className="nb-root" aria-label="Primary">
      <div className="nb-inner">

        {/* Logo */}
        <a href="#top" className="nb-logo-link" aria-label="EG-Bau – Startseite">
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="EG-BAU Logo"
            className="nb-logo"
          />
        </a>

        {/* Desktop links */}
        <ul className="nb-links" role="list">
          {NAV_LINKS.map(({ href, label }) => (
            <li key={href}>
              <a href={href} className="nb-link">{label}</a>
            </li>
          ))}
        </ul>

        {/* Desktop CTA */}
        <a href="#contact" className="nb-cta">
          <span>Anfrage</span>
        </a>

        {/* Hamburger */}
        <button
          className={`nb-burger${isMenuOpen ? " nb-burger--open" : ""}`}
          onClick={toggleMenu}
          aria-label={isMenuOpen ? "Menü schließen" : "Menü öffnen"}
          aria-expanded={isMenuOpen}
          aria-controls="nb-mobile-menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile fullscreen drawer */}
      <div
        id="nb-mobile-menu"
        className={`nb-drawer${isMenuOpen ? " nb-drawer--open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!isMenuOpen}
      >
        {/* Backdrop */}
        <div className="nb-drawer-backdrop" onClick={closeMenu} aria-hidden />

        {/* Panel */}
        <div className="nb-drawer-panel">
          {/* Top bar inside drawer */}
          <div className="nb-drawer-top">
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="EG-BAU Logo"
              className="nb-drawer-logo"
            />
            <button
              className="nb-drawer-close"
              onClick={closeMenu}
              aria-label="Menü schließen"
            >
              ✕
            </button>
          </div>

          {/* Links */}
          <ul className="nb-drawer-links" role="list">
            {NAV_LINKS.map(({ href, label }, i) => (
              <li
                key={href}
                style={{ transitionDelay: isMenuOpen ? `${i * 70 + 100}ms` : "0ms" }}
              >
                <a href={href} className="nb-drawer-link" onClick={closeMenu}>
                  <span className="nb-drawer-num">0{i + 1}</span>
                  {label}
                </a>
              </li>
            ))}
          </ul>

          {/* Bottom CTA */}
          <a href="#contact" className="nb-drawer-cta" onClick={closeMenu}>
            Jetzt Anfrage stellen
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;